module.exports = __webpack_public_path__ + "img/icon_symbol.9d7a1ae7.png";